import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";

import DupontButton from "components/DupontButton";
import DupontIconButton from "components/DupontIconButton";

import BackIcon from "assets/SvgIcon/BackIcon";

import { useStyles } from "./widgetModalStyle";

const CustomModal = React.forwardRef((props: any, ref) => {
  const classes = useStyles(this);
  const {
    show,
    title,
    description,
    secondaryDescription,
    confirmBtnText,
    confirmBtnAction,
    close,
    confirmDisabled,
    customClass,
    isBackBtnHidden,
    id
  } = props;
  const cancelBtnText = props.cancelBtnText || "Cancel";
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const closeBtnHandler = () => {
    // setShowModal(false);
    if (close) close();
  };
  const addBtnHandler = () => {
    if (confirmBtnAction) confirmBtnAction();
  };

  const backBtnHandler = () => {
    if (close) close("BackBtn");
  };

  return (
    <Modal
      id={id}
      open={showModal}
      onClose={closeBtnHandler}
      hideBackdrop={true}
      disableEnforceFocus
      className={classes.modal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div className={classes.paper}>
        <header className={classes.modalHeader}>
          <div className="title">
            {confirmBtnText && !isBackBtnHidden && (
              <span className={classes.backIcon} onClick={backBtnHandler}>
                <DupontIconButton tooltip={props?.backBtnTooltip}>
                  <BackIcon />
                </DupontIconButton>
              </span>
            )}
            <h2 id="modal_title" className={classes.title}>
              {title}
            </h2>
          </div>
          <p id="modal_description" className={classes.description}>
            <span id="modal_description_primary">{description}</span>
            {secondaryDescription && <span id="modal_description_secondary" className={classes.description_secondary}>{secondaryDescription} </span>}
          </p>
        </header>
        <main className={`${classes.modalBody} ${customClass}`}> {props.children} </main>
        <footer className={classes.modalFooter}>
          <DupontButton type="secondary" onClick={closeBtnHandler} customClass={classes.btnSpacing}>
            {cancelBtnText}
          </DupontButton>
          {confirmBtnText && (
            <DupontButton type="primary" disabled={confirmDisabled} onClick={addBtnHandler}>
              {confirmBtnText}
            </DupontButton>
          )}
        </footer>
      </div>
    </Modal>
  );
});

export default CustomModal;
